export const environment = {
  PRODUCTION: false,
  API_IMPERIA_URL: 'https://dev-apim-lynsafe.azure-api.net/api/imperia/bi',
  API_SUITEEDGE_URL: 'https://dev-apim-lynsafe.azure-api.net/api/suiteedge/bi',
  PROVIDER_TYPE_STORAGE_KEY: 'provider_type',
  IMPERIA_AD_SCOPES:
    'openid profile email offline_access api://lynnco.com/apim-lynsafe-dev/.default',
  IMPERIA_AD_CLIENT_ID: '4793e949-0981-4574-a757-0813922c2ef4',
  IMPERIA_ISSUER: 'https://login.microsoftonline.com/organizations/v2.0',
  IMPERIA_AD_REDIRECT_URI: 'https://bi.dev.lynnco.com/login-callback',
  IMPERIA_SITE_URI: 'https://dev-imperia.azurewebsites.net/',
  B2C_SCOPES:
    'openid https://devsuiteedge.onmicrosoft.com/d90df4f4-bc51-4d1d-bc07-08ab708d31c9/user_impersonation',
  B2C_CLIENT_ID: '40f772aa-909e-4dab-95ac-2c8c4cdb64b5',
  B2C_ISSUER: 'https://devsuiteedge.b2clogin.com/devsuiteedge.onmicrosoft.com/b2c_1_susi_dev/v2.0/',
  B2C_REDIRECT_URI: 'https://bi.dev.lynnco.com/login-callback',
  B2C_SITE_URI: 'https://dev-suiteedge3.lynnco.com/home',
};
